<template>
  <div class="my-2 flex flex-wrap gap-3">
    <inertia-link
      v-for="(tag, index) in displayedTags"
      :key="index"
      :href="route+'?search=' + encodeURIComponent(tag)"
      as="button"
      class="bg-primary-color text-white px-2 py-1 rounded-md text-sm cursor-pointer"
    >
      {{ tag }}
    </inertia-link>
  </div>
</template>

<script>
export default {
  props: {
    tags: String,
    route: String,
  },

  computed: {
    displayedTags() {
      if(!this.tags){
        return [];
      }
      return this.tags.split(",");
    },
  },
};
</script>